export function arrayToRecord<T, K extends keyof T>(
  array: Array<T>,
  indexKeyName: K
): Record<string, T> {
  return array.reduce<Record<string, T>>((prev, curr) => {
    prev[curr[indexKeyName] as unknown as string] = curr;
    return prev;
  }, {} as Record<string, T>);
}
